import { WidgetEnv } from "@xapp/stentor-chat-widget";
import React, { FC, useMemo } from "react";
import { ChatDetail } from "../../store/ChatAction";
import { createStateFromMessages } from "../../store/ChatStaticStore";
import { ChatWidgetMode } from "./ChatWidget";
import StaticChatWidgetContainer from "./StaticChatWidgetContainer";

export interface StaticMessagesChatWidgetContainerProps {
    readonly messages: readonly ChatDetail[],
    readonly mode?: ChatWidgetMode;
    readonly config: Omit<WidgetEnv, "connection">;
}

const StaticMessagesChatWidgetContainer: FC<StaticMessagesChatWidgetContainerProps> = props => {

    const { messages } = props;

    const state = useMemo(() => {
        return createStateFromMessages(messages);
    }, [messages]);

    return (
        <StaticChatWidgetContainer
            state={state}
            mode={props.mode}
            config={props.config}
        />
    );
}

export default StaticMessagesChatWidgetContainer;